import { SortableHeader } from '@/components/search/SortableHeader'
import { useTableSort } from '@/components/search/useTableSort'
import "./OperatorMachineStatsPop.css";

import React from "react";
import type { OperatorMachineStats } from "./types"; // adjust path as needed
import { useAppContext } from "@/context/app";
import { Spinner } from "@/components/spinner";
import { MachineName } from "@/components/machine";

export type OperatorMachineStatsViewProps = {
  data: OperatorMachineStats;
  className?: string;
};

const numberFmt = new Intl.NumberFormat(undefined, { maximumFractionDigits: 3 });

export function OperatorMachineStatsPopup({
  data,
}: OperatorMachineStatsViewProps) {
  const { translates } = useAppContext()
  let op = data
  const sorted = useTableSort(op.machines, {
    machine: row => [row.manufacturer, row.model, row.internalNumber].filter(Boolean).join(' > '),
    maxHit: row => row.maxHit,
    hitCounter: row => row.hitCounter,
  })

  if (!translates) {
    return <Spinner />
  }

  const openMachineDetails = (machineId: string) => {
    const url = `${window.location.origin}/communal/statistics/machines?length=1d&machine=${machineId}`;
    window.open(url, '_blank');
  }

  return (
    <section className="operator-machine-stats-popup omsv__card" key={op.operatorId}>
      <header className="omsv__header">
        <div className="omsv__headerLeft">
          <div className="omsv__title">{translates.for('report.operatorusage.summary.table.username')}: {op.username}</div>
          {/* <div className="omsv__subtle">{translates.for('report.operatorusage.summary.table.username')}:: {op.operatorId}</div> */}
        </div>

        <div className="omsv__headerRight">
          <div>
            <span className="omsv__label">{translates.for('report.operatorusage.summary.table.hit_counter')}: </span>
            <strong>{op.hitCounter}</strong>
          </div>
          <div>
            <span className="omsv__label">{translates.for('report.operatorusage.summary.table.max_hit')}: </span>
            <strong>{numberFmt.format(op.maxHit)}</strong>
          </div>
        </div>
      </header>

      <div className="omsv__machines">
        <details open>
          <summary className="omsv__summary">
            {translates.for('report.operatorusage.summary.details.machines')} ({op.machines.length})
          </summary>

          <div className="omsv__tableWrap">
            <table className="omsv__table">
              <thead>
                <tr>
                  <SortableHeader as='th' field='machine' query={sorted.query} onSort={sorted.onSort}>{translates.for('report.operatorusage.summary.details.table.machine')}</SortableHeader>
                  <SortableHeader as='th' field='maxHit' query={sorted.query} onSort={sorted.onSort}>{translates.for('report.operatorusage.summary.details.table.max_hit')}</SortableHeader>
                  <SortableHeader as='th' field='hitCounter' query={sorted.query} onSort={sorted.onSort}>{translates.for('report.operatorusage.summary.details.table.hit_counter')}</SortableHeader>
                </tr>
              </thead>
              <tbody>
                {sorted.rows.map((m) => (
                  <tr key={m.machineId}>
                    <td onClick={() => {
                      openMachineDetails(m.machineId)
                    }}>
                      <MachineName row={{
                        internalNumber: m.internalNumber,
                        type: {
                          category: m.category,
                          manufacturer: m.manufacturer,
                          model: m.model
                        }
                      }} />
                    </td>
                    <td className="omsv__num">{numberFmt.format(m.maxHit)}</td>
                    <td className="omsv__num">{m.hitCounter}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </details>
      </div>
    </section>
  );
}